<template>
  <div>
    <md-button
      v-if="settings.video"
      class="md-raised"
      :class="[{ 'md-accent': type === 'video' }, { 'md-primary': true }]"
      @click.prevent="type = 'video'"
    >
      <md-icon>videocam</md-icon>
      Video-Aufnahme
    </md-button>
    <md-button
      v-if="settings.audio"
      class="md-raised md-primary"
      :class="[{ 'md-accent': type === 'audio' }, { 'md-primary': true }]"
      @click.prevent="type = 'audio'"
    >
      <md-icon>mic</md-icon>
      Audio-Aufnahme
    </md-button>
    <md-button
      v-if="settings.screencast"
      class="md-raised md-primary"
      :class="[{ 'md-accent': type === 'screencast' }, { 'md-primary': true }]"
      @click.prevent="type = 'screencast'"
    >
      <md-icon>airplay</md-icon>
      Monitor-Screen-Aufnahme <md-icon>volume_off</md-icon>
    </md-button>
    <div v-if="type === 'video'">
      <videoRecorder :onSave="save" :fileName="fileName" :uploadTarget="settings.uploadTarget"></videoRecorder>
    </div>
    <div v-if="type === 'audio'">
      <audioRecorder :onSave="save" :fileName="fileName" :uploadTarget="settings.uploadTarget"></audioRecorder>
    </div>
    <div v-if="type === 'screencast'">
      <screenRecorder :onSave="save" :fileName="fileName" :uploadTarget="settings.uploadTarget"></screenRecorder>
      <md-icon>info</md-icon> Monitor-Screen-Aufnahme funktioniert nicht auf
      Smartphones!
      <br />
      <md-icon>info</md-icon> Monitor-Screen-Aufnahme ohne Soundaufzeichnung!
    </div>
    <div id="header"></div>
  </div>
</template>
<script>
export default {
  components: {
    videoRecorder() {
      return import("@/components/recorder/parts/video.vue");
    },
    audioRecorder() {
      return import("@/components/recorder/parts/audio.vue");
    },
    screenRecorder() {
      return import("@/components/recorder/parts/screen.vue");
    }
  },
  props: {
    settings: Object,
    name: [String, Number],
    onUpload: Function
  },
  data() {
    return {
      type: false,
      uploadUrl: this.settings.uploadTarget,
      fileName: this.getFileName()
    };
  },
  methods: {
    getFileName() {
      var d = new Date();
      return (
        d.getFullYear() +
        "-" +
        (d.getMonth() + 1) +
        "-" +
        d.getDate() +
        "-" +
        d.getHours() +
        "-" +
        d.getMinutes() +
        "-" +
        d.getSeconds() +
        "-" +
        this.getBeautifyName(this.name) +
        "-" +
        this.getBeautifyName(this.settings.project)
      );
    },
    getBeautifyName(name) {
      name = name.toLowerCase();
      name = name
        .split(" ")
        .join("_")
        .split("ä")
        .join("ae")
        .split("ö")
        .join("oe")
        .split("ü")
        .join("ue")
        .split("ß")
        .join("ss");
      let regex = /[^a-zA-Z0-9]/g;
      name = name.replace(regex, "");
      return name;
    },
    save(fileBlob, type) {
      var fileObject;
      if (type === "video") {
        fileObject = new File([fileBlob], this.fileName + ".webm", {
          type: "video/webm"
        });
      }
      if (type === "audio") {
        fileObject = new File([fileBlob], this.fileName + ".mp3", {
          type: "audio/mp3"
        });
      }

      this.uploadToPHPServer(
        fileObject,
        function(response) {
          if (response !== "ended") {
            document.getElementById("header").innerHTML = response; // upload progress
            return;
          }

          document.getElementById("header").innerHTML =
            "Erfolgreich gespeichert! Hier die Quittung:<br>" +
            "<b>" +
            this.fileName +
            "</b>";

          this.onUpload(this.fileName);
        }.bind(this)
      );
    },
    uploadToPHPServer(blob, callback) {
      // create FormData
      var formData = new FormData();
      formData.append("video-filename", blob.name);
      formData.append("video-blob", blob);
      callback("Lade Aufnahme zum Server.");

      var upload_url = this.uploadUrl;
      // var upload_url = 'RecordRTC-to-PHP/save.php';

      var upload_directory = upload_url;
      // var upload_directory = 'RecordRTC-to-PHP/uploads/';

      this.makeXMLHttpRequest(upload_url, formData, function(progress) {
        if (progress !== "upload-ended") {
          callback(progress);
          return;
        }
        var initialURL = upload_directory + blob.name;
        callback("ended", initialURL);
      });
    },
    makeXMLHttpRequest(url, data, callback) {
      var request = new XMLHttpRequest();
      request.onreadystatechange = function() {
        if (request.readyState == 4 && request.status == 200) {
          if (request.responseText === "success") {
            callback("upload-ended");
            return;
          }
          alert(request.responseText);
          return;
        }
      };
      request.upload.onloadstart = function() {
        callback("Upload beginnt...");
      };
      request.upload.onprogress = function(event) {
        callback(
          "Upload Prozess " +
            Math.round((event.loaded / event.total) * 100) +
            "%"
        );
      };
      request.upload.onload = function() {
        callback("progress-about-to-end");
      };
      request.upload.onload = function() {
        callback("Upload beendet.");
      };
      request.upload.onerror = function() {
        callback("Upload Fehler");
      };
      request.upload.onabort = function() {
        callback("Upload abgebrochen");
      };
      request.open("POST", url);
      request.send(data);
    }
  },
  mounted() {},
  computed: {}
};
</script>
<style lang="sass" scoped>
#header
  margin-top: 20px
</style>
